import React from 'react'

import * as Yup from 'yup'
import { Form, Input, Select } from 'formik-antd'
import { BasicForm } from '../../../../core/components/form'
import { useUpdateStorage, useFetch } from '../../../../hooks/admin/settings/storage'
import { useHistory } from 'react-router-dom'
import Loader from '../../../../components/loader'
import { isNotValid, translateSymfonyErrorToFormik } from '../../../../core/utils/form'

const ValidationSchema = Yup.object().shape({
  storage: Yup.string().required('Cannot be blank.')
})

const Formulario = () => {
  const { data, isLoading, isError } = useFetch()
  const update = useUpdateStorage()
  const history = useHistory()

  function handleSubmit (values, bag) {
    const form = { ...values }

    update.mutate(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        onPressBack()
      },
      onError: (error, variables, context) => {
        bag.setSubmitting(false)
        if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
      }
    })
  }

  const onPressBack = () => history.goBack()

  if (isLoading) {
    return (<Loader loading={isLoading} />)
  }

  if (isError) {
    return (<>Error</>)
  }

  const initialValues = {
    storage: data.entity.storage,

    key: data.entity?.key,
    secret: data.entity?.secret,
    region: data.entity?.region,
    endpoint: data.entity?.endpoint,
    bucket: data.entity?.bucket,
    prefix: data.entity?.prefix,

    box_client_id: data.entity?.box_client_id,
    box_client_secret: data.entity?.box_client_secret,
    box_enterprise_id: data.entity?.box_enterprise_id,
    box_folder_id: data.entity?.box_folder_id
  }

  return (
    <BasicForm
      onPressBack={onPressBack}
      titulo='Storage'
      initialValues={initialValues}
      validationSchema={ValidationSchema}
      onSubmit={handleSubmit}
      render={({ values }) => (
        <>
          <Form.Item label='Storage' name='storage' required>
            <Select name='storage' style={{ width: '100%' }}>
              <Select.Option value='S3'>S3 Integration</Select.Option>
              <Select.Option value='Box'>Box Integration (Deprecated)</Select.Option>
            </Select>
          </Form.Item>

          {values.storage === 'S3' && (
            <>
              <Form.Item name='key' label='Key' required>
                <Input name='key' />
              </Form.Item>
              <Form.Item name='secret' label='Secret' required>
                <Input name='secret' password />
              </Form.Item>
              <Form.Item name='region' label='Region' required>
                <Input name='region' />
              </Form.Item>
              <Form.Item name='bucket' label='Bucket' required>
                <Input name='bucket' />
              </Form.Item>
              <Form.Item name='endpoint' label='Endpoint'>
                <Input name='endpoint' />
              </Form.Item>
              <Form.Item name='prefix' label='Prefix' required>
                <Input name='prefix' />
              </Form.Item>
            </>
          )}
          {values.storage === 'Box' && (
            <>
              <Form.Item
                name='box_client_id'
                label='Client ID'
                required
              >
                <Input name='box_client_id' />
              </Form.Item>
              <Form.Item
                name='box_client_secret'
                label='Client Secret'
                required
              >
                <Input.Password name='box_client_secret' />
              </Form.Item>
              <Form.Item
                name='box_enterprise_id'
                label='Enterprise ID'
                required
              >
                <Input name='box_enterprise_id' />
              </Form.Item>
            </>
          )}
        </>
      )}
    />
  )
}

export default Formulario
